export const DXG_PUBLISHED_VERSION_BAGGAGE_NAME = 'deal360.publishedVersion';
export const DXG_DEALER_REVIEW_BAGGAGE_NAME = 'deal360.dealerReview';
